module.exports = __webpack_public_path__ + "img/nophoto.8f01d751.png";